import React from 'react';
import { Link, Head } from '@inertiajs/react';
import BlogLayout from '@/Layouts/BlogLayout';

export default function Index({ blogs, canManage }) {
    return (
        <BlogLayout
            title="Our Blog - Hollywood Royale Garden"
            description="Read the latest stories, news, and updates from Hollywood Royale Garden assisted living community."
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row justify-between items-center mb-12 gap-6">
                    <div>
                        <span className="text-[#d4a575] font-semibold tracking-widest uppercase text-sm mb-2 block">
                            Blog & News
                        </span>
                        <h1 className="text-4xl md:text-5xl font-display font-medium text-[#0a3f26]">
                            Latest Stories
                        </h1>
                    </div>
                    {canManage && (
                        <Link
                            href={route('blogs.create')}
                            className="bg-[#0a3f26] hover:bg-[#062416] text-[#d4a575] font-semibold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg"
                        >
                            Create New Post
                        </Link>
                    )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                    {blogs.data.length > 0 ? (
                        blogs.data.map((blog) => (
                            <Link href={route('blogs.show', blog.slug)} key={blog.id} className="group h-full block">
                                <div className="bg-white overflow-hidden rounded-[2rem] h-full border border-gray-100 hover:border-[#d4a575]/30 shadow-sm hover:shadow-2xl hover:shadow-[#0a3f26]/10 transition-all duration-500 flex flex-col">
                                    <div className="relative aspect-[16/10] overflow-hidden">
                                        {blog.image ? (
                                            <img
                                                src={blog.image}
                                                alt={blog.title}
                                                className="w-full h-full object-contain md:object-cover transform group-hover:scale-105 transition-transform duration-700"
                                            />
                                        ) : (
                                            <div className="w-full h-full bg-[#0a3f26]/5 flex items-center justify-center">
                                                <span className="text-[#0a3f26]/20 font-display text-4xl">HR</span>
                                            </div>
                                        )}
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                                        {/* Status Badge for Admin */}
                                        {canManage && (
                                            <div className="absolute top-4 right-4">
                                                <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider backdrop-blur-md
                                                    ${blog.status === 'published' ? 'bg-green-500/80 text-white' :
                                                        blog.status === 'scheduled' ? 'bg-blue-500/80 text-white' :
                                                            'bg-gray-500/80 text-white'}`}>
                                                    {blog.status}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="p-8 flex-grow flex flex-col">
                                        <div className="flex items-center justify-between mb-4">
                                            <div className="text-xs font-bold tracking-widest uppercase text-[#d4a575]">
                                                {new Date(blog.scheduled_at || blog.created_at).toLocaleDateString(undefined, {
                                                    month: 'long',
                                                    day: 'numeric',
                                                    year: 'numeric'
                                                })}
                                            </div>
                                        </div>
                                        <h2 className="text-2xl font-display font-medium text-[#0a3f26] mb-4 group-hover:text-[#d4a575] transition-colors line-clamp-2 leading-tight">
                                            {blog.title}
                                        </h2>
                                        <p className="text-gray-600 text-sm line-clamp-3 mb-6 leading-relaxed flex-grow">
                                            {blog.content.replace(/<[^>]*>?/gm, '')}
                                        </p>
                                        <div className="flex items-center text-[#0a3f26] font-semibold group-hover:text-[#d4a575] transition-colors pt-6 border-t border-gray-100 mt-auto">
                                            Read Story
                                            <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-2 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))
                    ) : (
                        <div className="col-span-full py-20 text-center">
                            <p className="text-gray-500 text-lg">No stories found yet. Stay tuned!</p>
                        </div>
                    )}
                </div>

                {/* Pagination */}
                {blogs.links.length > 3 && (
                    <div className="mt-16 flex justify-center">
                        <div className="flex flex-wrap gap-2">
                            {blogs.links.map((link, key) => (
                                link.url === null ? (
                                    <div
                                        key={key}
                                        className="px-4 py-2 text-gray-400 border border-gray-100 rounded-lg text-sm"
                                        dangerouslySetInnerHTML={{ __html: link.label }}
                                    />
                                ) : (
                                    <Link
                                        key={key}
                                        href={link.url}
                                        className={`px-4 py-2 border rounded-lg text-sm font-semibold transition-all
                                            ${link.active
                                                ? 'bg-[#0a3f26] text-[#d4a575] border-[#0a3f26]'
                                                : 'bg-white text-gray-700 border-gray-100 hover:border-[#d4a575] hover:text-[#d4a575]'
                                            }`}
                                        dangerouslySetInnerHTML={{ __html: link.label }}
                                    />
                                )
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </BlogLayout>
    );
}
